import {
  GroupOrderBagCancelButton,
  GroupOrderBagLeaveButton,
  GroupOrderBagShareButton,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagButton = {
  Share: GroupOrderBagShareButton,
  Cancel: GroupOrderBagCancelButton,
  Leave: GroupOrderBagLeaveButton,
};
